export default "__VITE_ASSET__CJd6mCZg__"